<template>
  <v-row class="align-center my-0">
      <v-col v-if="title" cols="12" sm="4" class="py-0 text-sm-right">
          <span class="caption" style="line-height: 0.9rem !important;">{{ title }}</span>
      </v-col>
      <v-col class="py-0 d-flex align-center">
          <div
              v-for="(bar, index) in barColors[type]"
              :index="index"
              :style="{width:`${distro[index]}%`, position: 'relative'}"
          >
              <div
                  :style="{height: barHeight, width: `100%` , background: colors[bar], opacity: 0.4}"
              />
              <div v-if="distro[index] >= 8"
                   style="width:100%;position:absolute;top:-0.325rem;left:0;"
                   class="text-center caption"
              >{{distro[index]}}%</div>
          </div>
      </v-col>
      <v-col v-if="value" class="py-0 pl-0" style="max-width:50px;">
          <span class="grey--text" v-if="options && options.average">Ø </span>
          <strong v-if="options && options.boldScore" style="font-style: italic">{{ scoreNum(value) }}</strong>
          <span v-else class="caption" style="font-style: italic">{{ scoreNum(value) }}</span>
      </v-col>
  </v-row>
</template>

<script>
export default {
    name: "distribution",
    props: ['title', 'value', 'distro','type','options'],
    data() {
        return {
            barHeight: '10px',
            barColors: {
                motivator: ['green', 'lgreen', 'yellow', 'lred', 'red'],
                parameter: ['lred', 'green', 'lred'],
                role: ['lgreen', 'yellow', 'lred'],
                motivation: ['red','lred','yellow','lgreen','green']
            }
        }
    },
    computed: {
        colors() {
            return this.$store.getters['app/colors']
        }
    },
    methods: {
        scoreNum(score){
            if (score < 9.947) {
                return score.toFixed(1)
            } else {
                return 10
            }
        },
    }
}
</script>